import { useRef, useState } from 'react';

import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';

import Button from '../Button/Button.component';

import { getCroppedImageFile } from 'utils/crop-image';

import { useStyles } from './PictureCropper.styles';

// Preview con recorte antes de guardar. `src` es un object URL del archivo que
// acaba de elegir el usuario; el componente no sube nada, solo entrega el File
// recortado a `onConfirm` para que el padre decida qué hacer con él.
const PictureCropper = ({
  src,
  aspect,
  isLoading,
  title = 'Ajustar fotografía',
  onCancel,
  onConfirm,
}) => {
  const [crop, setCrop] = useState({ unit: '%', width: 90, aspect });
  const [pixelCrop, setPixelCrop] = useState(null);

  // La etiqueta <img> que monta ReactCrop. Se guarda en un ref y no en estado
  // porque solo se lee al confirmar y no debe provocar renders.
  const imageRef = useRef(null);

  const classes = useStyles();

  const onImageLoadedHandler = image => {
    imageRef.current = image;
  };

  const onConfirmHandler = async () => {
    if (!imageRef.current || !pixelCrop?.width || !pixelCrop?.height) {
      return;
    }
    const file = await getCroppedImageFile(
      imageRef.current,
      pixelCrop,
      'establecimiento.jpg',
    );
    onConfirm(file);
  };

  const canConfirm = Boolean(pixelCrop?.width && pixelCrop?.height);

  return (
    <Dialog open fullWidth maxWidth="sm" onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography
          variant="body2"
          color="textSecondary"
          className={classes.hint}
        >
          Arrastra sobre la imagen para elegir la parte que se mostrará. Se
          guardará solo el área seleccionada.
        </Typography>
        <Box display="flex" justifyContent="center">
          <ReactCrop
            ruleOfThirds
            src={src}
            crop={crop}
            className={classes.cropper}
            onChange={setCrop}
            onComplete={setPixelCrop}
            onImageLoaded={onImageLoadedHandler}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={onCancel}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!canConfirm || isLoading}
          loading={isLoading}
          onClick={onConfirmHandler}
        >
          Guardar fotografía
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PictureCropper;
